import { useEffect } from "react";
import { upsertCanonical, upsertMeta } from "@/lib/head";
import HeroSection from "@/components/HeroSection";
import TrustStrip from "@/components/TrustStrip";
import HowItWorks from "@/components/HowItWorks";
import QuoteForm from "@/components/QuoteForm";
import ServicesSection from "@/components/ServicesSection";
import BrandStatement from "@/components/BrandStatement";
import SkipTheSkip from "@/components/SkipTheSkip";
import LoadSizeGuide from "@/components/LoadSizeGuide";
import BeforeAfter from "@/components/BeforeAfter";
import MovingSimpleSection from "@/components/MovingSimpleSection";
import MoveWasteCrossover from "@/components/MoveWasteCrossover";
import ReviewsSection from "@/components/ReviewsSection";
import ComparisonSection from "@/components/ComparisonSection";
import WhatWeTake from "@/components/WhatWeTake";
import SpecialItems from "@/components/SpecialItems";
import FaqSection from "@/components/FaqSection";
import SocialProofStats from "@/components/SocialProofStats";
import FinalCta from "@/components/FinalCta";
import Footer from "@/components/Footer";
import StickyCallButton from "@/components/StickyCallButton";

const SITE = "https://ozwasteco.com.au";
const HOME_TITLE = "Rubbish Removal Melbourne | OZ WASTE CO. Fast, Upfront Quotes";
const HOME_DESC =
  "Fast rubbish removal across Melbourne. Household junk, furniture, garage, move-out and property clear-outs, we do the lifting and loading. Get a free upfront quote today.";

const Index = () => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = HOME_TITLE;
    const cleanups = [
      upsertMeta("name", "description", HOME_DESC),
      upsertMeta("property", "og:title", HOME_TITLE),
      upsertMeta("property", "og:description", HOME_DESC),
      upsertMeta("property", "og:url", `${SITE}/`),
      upsertMeta("name", "twitter:title", HOME_TITLE),
      upsertMeta("name", "twitter:description", HOME_DESC),
      upsertCanonical(`${SITE}/`),
    ];
    return () => {
      document.title = prevTitle;
      cleanups.forEach((fn) => fn());
    };
  }, []);

  return (
  <main>
    <HeroSection />
    <TrustStrip />
    <HowItWorks />
    <QuoteForm />
    <ServicesSection />
    <BrandStatement />
    <SkipTheSkip />
    <LoadSizeGuide />
    <BeforeAfter />
    <MovingSimpleSection />
    <MoveWasteCrossover />
    <ReviewsSection />
    <ComparisonSection />
    <WhatWeTake />
    <SpecialItems />
    <FaqSection />
    <SocialProofStats />
    <FinalCta />
    <Footer />
    <StickyCallButton />
  </main>
  );
};

export default Index;
